import { useGetRecentOrders } from '@apps-common/apis/portal/orders/get-recent-orders'
import { OrderListCardSm, OrderListCardSmSkeleton } from '@apps-common/apps/portal/pages/orders/components'
import { PageSubtitle } from '@apps-common/components/common/portal-title'
import { ButtonRoundArrow } from '@apps-common/components/elements/button'
import { commonIcons } from '@apps-common/config/icons'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { ROUTE_ORDERS } from '@apps-radionet-portal/config/private-routes'
import { DashNoResultsCard } from '../DashNoResultsCard'

export const RecentOrdersCard = () => {
  const { navigateRoot } = useNavigation()
  const { isLoading, isError, data } = useGetRecentOrders({ take: 4 })

  const loading = isLoading || isError || !data

  return (
    <div className='relative bg-surface-2 w-full h-[100%] rounded-3xl overflow-y-scroll scrollbar-none border-[1px] border-border'>
      <div className='absolute z-[10] top-0 left-0 pt-4 px-6 sm:pt-7 sm:px-7 pb-[10px] w-full rounded-t-3xl backdrop-blur'>
        <div className='flex items-center justify-between'>
          <PageSubtitle>Recent orders</PageSubtitle>
          <ButtonRoundArrow
            disabled={loading}
            classes='bg-brand'
            iconClasses='text-on-brand'
            callback={() => navigateRoot({ routeUrl: ROUTE_ORDERS.buildPath(), route: ROUTE_ORDERS })}
            tooltip={{
              id: `dashboard-orders-view-all-tooltip`,
              message: 'View all'
            }}
          />
        </div>
      </div>
      <div className='relative z-[1] grid gap-[15px] !pt-[70px] sm:!pt-[105px] px-5 sm:p-7'>
        {loading &&
          Array.from(Array(4).keys()).map((k) => (
            <OrderListCardSmSkeleton
              key={`recent-orders-${k}`}
              bgClasses='bg-skeleton border-skeleton-border'
              bgSecondaryClasses='bg-skeleton-hi'
            />
          ))}
        {!loading &&
          data?.map((d, i) => (
            <OrderListCardSm
              key={`recent-orders-${d.orderId}-${i}`}
              bgClasses='bg-surface border border-border'
              textClasses='text-text'
              order={d}
            />
          ))}
        {!loading && data.length === 0 && <DashNoResultsCard Icon={commonIcons.sbOrders}>You have no recent orders</DashNoResultsCard>}
      </div>
    </div>
  )
}
